"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRequestStatus = getRequestStatus;
exports.fetchBookInfoFailed = exports.isSubmittingMeeting = exports.shouldRenderBookingPage = exports.bookingPageLoading = exports.getIsFetchingCompanyName = exports.meetingsUserFetchSuccess = exports.meetingsUserFetchFailed = exports.meetingsUserFetchStarted = exports.getIsFetchingOwnerPublicAvailability = exports.getIsFetchingPublicAvailability = exports.availabilityFetchSuccess = exports.availabilityFetchFailed = exports.meetingCreationFailed = exports.meetingCreationSuccess = exports.getCompanyNameFetchStatus = exports.getPublicGlobalBrandingFetchStatus = exports.getPublicAvailabilityOwnerFetchStatus = exports.getPublicAvailabilityInfoFetchStatus = exports.getMeetingsCreateStatus = void 0;

var _reselect = require("reselect");

var _get = _interopRequireDefault(require("transmute/get"));

var _RequestStatusTypes = require("MeetingsBase/constants/RequestStatusTypes");

var getRequestStatuses = function getRequestStatuses(state) {
  return state.requestStatus;
};

function getRequestStatus(requestType) {
  return (0, _reselect.createSelector)([getRequestStatuses], function (requestStatuses) {
    return requestStatuses.get(requestType) || _RequestStatusTypes.UNINITIALIZED;
  });
}

var getBookInfo = (0, _get.default)('bookInfo');
var getMeetingsCreateStatus = getRequestStatus('MEETING_CREATE');
exports.getMeetingsCreateStatus = getMeetingsCreateStatus;
var getPublicAvailabilityInfoFetchStatus = getRequestStatus('PUBLIC_AVAILABILITY_INFO_FETCH');
exports.getPublicAvailabilityInfoFetchStatus = getPublicAvailabilityInfoFetchStatus;
var getPublicAvailabilityOwnerFetchStatus = getRequestStatus('PUBLIC_AVAILABILITY_INFO_OWNER_FETCH');
exports.getPublicAvailabilityOwnerFetchStatus = getPublicAvailabilityOwnerFetchStatus;
var getMeetingsUserFetchStatus = getRequestStatus('MEETINGS_USER_FETCH');
var getPublicGlobalBrandingFetchStatus = getRequestStatus('PUBLIC_GLOBAL_BRANDING_FETCH');
exports.getPublicGlobalBrandingFetchStatus = getPublicGlobalBrandingFetchStatus;
var getCompanyNameFetchStatus = getRequestStatus('COMPANY_NAME_FETCH');
exports.getCompanyNameFetchStatus = getCompanyNameFetchStatus;
var meetingCreationSuccess = (0, _reselect.createSelector)([getMeetingsCreateStatus], function (meetingsCreateStatus) {
  return meetingsCreateStatus === _RequestStatusTypes.SUCCEEDED;
});
exports.meetingCreationSuccess = meetingCreationSuccess;
var meetingCreationFailed = (0, _reselect.createSelector)([getMeetingsCreateStatus], function (meetingsCreateStatus) {
  return meetingsCreateStatus === _RequestStatusTypes.FAILED;
});
exports.meetingCreationFailed = meetingCreationFailed;
var availabilityFetchFailed = (0, _reselect.createSelector)([getPublicAvailabilityInfoFetchStatus], function (publicAvailabilityInfoFetchStatus) {
  return publicAvailabilityInfoFetchStatus === _RequestStatusTypes.FAILED;
});
exports.availabilityFetchFailed = availabilityFetchFailed;
var availabilityFetchSuccess = (0, _reselect.createSelector)([getPublicAvailabilityInfoFetchStatus], function (publicAvailabilityInfoFetchStatus) {
  return publicAvailabilityInfoFetchStatus === _RequestStatusTypes.SUCCEEDED;
});
exports.availabilityFetchSuccess = availabilityFetchSuccess;
var getIsFetchingPublicAvailability = (0, _reselect.createSelector)([getPublicAvailabilityInfoFetchStatus], function (publicAvailabilityInfoFetchStatus) {
  return publicAvailabilityInfoFetchStatus === _RequestStatusTypes.UNINITIALIZED || publicAvailabilityInfoFetchStatus === _RequestStatusTypes.STARTED;
});
exports.getIsFetchingPublicAvailability = getIsFetchingPublicAvailability;
var getIsFetchingOwnerPublicAvailability = (0, _reselect.createSelector)([getPublicAvailabilityOwnerFetchStatus], function (publicAvailabilityOwnerFetchStatus) {
  return publicAvailabilityOwnerFetchStatus === _RequestStatusTypes.UNINITIALIZED || publicAvailabilityOwnerFetchStatus === _RequestStatusTypes.STARTED;
});
exports.getIsFetchingOwnerPublicAvailability = getIsFetchingOwnerPublicAvailability;
var meetingsUserFetchStarted = (0, _reselect.createSelector)([getMeetingsUserFetchStatus], function (meetingsUserFetchStatus) {
  return meetingsUserFetchStatus === _RequestStatusTypes.STARTED;
});
exports.meetingsUserFetchStarted = meetingsUserFetchStarted;
var meetingsUserFetchFailed = (0, _reselect.createSelector)([getMeetingsUserFetchStatus], function (meetingsUserFetchStatus) {
  return meetingsUserFetchStatus === _RequestStatusTypes.FAILED;
});
exports.meetingsUserFetchFailed = meetingsUserFetchFailed;
var meetingsUserFetchSuccess = (0, _reselect.createSelector)([getMeetingsUserFetchStatus], function (meetingsUserFetchStatus) {
  return meetingsUserFetchStatus === _RequestStatusTypes.SUCCEEDED;
});
exports.meetingsUserFetchSuccess = meetingsUserFetchSuccess;
var getIsFetchingCompanyName = (0, _reselect.createSelector)([getCompanyNameFetchStatus], function (companyNameFetchStatus) {
  return companyNameFetchStatus === _RequestStatusTypes.UNINITIALIZED || companyNameFetchStatus === _RequestStatusTypes.STARTED;
});
exports.getIsFetchingCompanyName = getIsFetchingCompanyName;
var bookingPageLoading = getIsFetchingPublicAvailability;
exports.bookingPageLoading = bookingPageLoading;
var shouldRenderBookingPage = (0, _reselect.createSelector)([bookingPageLoading, getMeetingsCreateStatus], function (isBookingPageLoading, meetingsCreateStatus) {
  var meetingNotCreatedYet = meetingsCreateStatus === _RequestStatusTypes.UNINITIALIZED || meetingsCreateStatus === _RequestStatusTypes.STARTED;
  return !isBookingPageLoading && meetingNotCreatedYet;
});
exports.shouldRenderBookingPage = shouldRenderBookingPage;
var isSubmittingMeeting = (0, _reselect.createSelector)([getMeetingsCreateStatus], function (meetingsCreateStatus) {
  return meetingsCreateStatus === _RequestStatusTypes.STARTED;
});
exports.isSubmittingMeeting = isSubmittingMeeting;
var fetchBookInfoFailed = (0, _reselect.createSelector)([getPublicAvailabilityInfoFetchStatus, getBookInfo], function (publicAvailabilityInfoFetchStatus, _ref) {
  var availableTimePeriods = _ref.availableTimePeriods;
  return publicAvailabilityInfoFetchStatus === _RequestStatusTypes.FAILED || !availableTimePeriods;
});
exports.fetchBookInfoFailed = fetchBookInfoFailed;